import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=0f1f3a88"
import script from "./selectProject.vue?vue&type=script&lang=js"
export * from "./selectProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports